export default {"src":"https://www.adfcareers.gov.au/_next/static/media/chevron-down.f55d5e5b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};